import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import Popup from '../../../components/elements/Popup'
import Dismissible from '../../../components/elements/Dismissible'
import Form from '../../../components/elements/Form'
import LocationSelect from '../../../components/elements/forms/LocationSelect'

import Types from '../../../actions/Types'
import FetchLocationsAction from '../../../actions/locations/ListLinearAction'
import PrintBatteriesAction from '../../../actions/print/PrintBatteriesAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class PrintBatteriesPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      selected: -1
    }

    // Bind events
    this.onChangeLocation = this.onChangeLocation.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchLocations()
  }

  componentDidUpdate(prevProps, prevState) {
    // When successful, close popup
    if (
      prevProps.isPrinting
      &&
      !this.props.isPrinting
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Liste des batteries imprimée.')
      this.props.onClose()
    }
  }

  onChangeLocation(selected) {
    this.setState({ selected })
  }

  onSubmit() {
    this.props.print(
      this.state.selected === -1
        ? 'all'
        : String(this.state.selected)
    )
  }

  render() {
    return (
      <Popup
        header='Imprimer la liste des batteries'
        body={
          <React.Fragment>
            {
              this.props.error
                ? <Dismissible
                    header={AppUtils.errorToTitle(this.props.error)}
                    content={AppUtils.errorToText(this.props.error)}
                    color='red'
                    onDismiss={this.props.clearError}
                  />
                : null
            }
            <Form
              onSubmit={this.onSubmit}
              loading={this.props.isPrinting}
            >
              <LocationSelect
                label='Emplacement'
                loading={this.props.locationsIsFetching}
                options={_.union(
                  [{
                    id: -1,
                    stickers: [{
                      name: 'Tous',
                      color: {
                        foreground: '000000',
                        background: 'ffffff'
                      }
                    }]
                  }],
                  this.props.locationsList
                )}
                selected={this.state.selected}
                onChange={this.onChangeLocation}
              />
            </Form>
          </React.Fragment>
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose()
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Imprimer',
            color: 'blue',
            icon: 'print',
            onClick: this.onSubmit
          }
        ]}
        isSaving={this.props.isPrinting}
      />
    )
  }
}

PrintBatteriesPopup.propTypes = {
  // Properties
  onClose: PropTypes.func.isRequired,

  // Redux State
  isPrinting: PropTypes.bool.isRequired,
  error: PropTypes.object,
  locationsList: PropTypes.array,
  locationsIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  print: PropTypes.func.isRequired,
  fetchLocations: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    isPrinting: state.print.batteries.isFetching,
    error: state.print.batteries.error,
    locationsList: state.entities.locations.list.linear.data,
    locationsIsFetching: state.entities.locations.list.linear.isFetching
  }),
  (dispatch) => ({
    print: (id) => (dispatch(PrintBatteriesAction({ id }))),
    fetchLocations: () => (dispatch(FetchLocationsAction({}))),
    clearError: () => dispatch(ClearErrorAction(Types.PRINT.BATTERIES))
  })
)(PrintBatteriesPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/batteries/PrintBatteriesPopup.js